import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FamilyMemberAccessLockedComponent } from './family-member-registration/family-member-access-locked/family-member-access-locked.component';
import { FamilyMemberPortalRegistrationComponent } from './family-member-registration/family-member-portal-registration/family-member-portal-registration.component';
import { FamilyMemberRegistrationComponent } from './family-member-registration/family-member-registration.component';
import { FamilyForgotPasswordComponent } from './family/family-forgot-password/family-forgot-password.component';
import { FamilyLoginComponent } from './family/family-login/family-login.component';
import { FamilyResetPasswordComponent } from './family/family-reset-password/family-reset-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './forgot-password/reset-password/reset-password.component';
import { InteractiveAccessForgotPasswordComponent } from './interactive-access/interactive-access-forgot-password/interactive-access-forgot-password.component';
import { InteractiveAccessLoginComponent } from './interactive-access/interactive-access-login/interactive-access-login.component';
import { InteractiveAccessResetPasswordComponent } from './interactive-access/interactive-access-reset-password/interactive-access-reset-password.component';
import { LearnerPortalRegistrationComponent } from './learner-registration/learner-portal-registration/learner-portal-registration.component';
import { LearnerRegistrationComponent } from './learner-registration/learner-registration.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'login/:token', component: LoginComponent, pathMatch: 'full' },
  { path: 'register', component: RegisterComponent, pathMatch: 'full' },
  {
    path: 'family-invite/:inviteId',
    component: FamilyMemberRegistrationComponent,
    pathMatch: 'full',
  },
  {
    path: 'family-members/confirm-invitation/:invitationId',
    component: FamilyMemberPortalRegistrationComponent,
    pathMatch: 'full',
  },
  {
    path: 'learner-invite/:inviteId',
    component: LearnerRegistrationComponent,
    pathMatch: 'full',
  },
  {
    path: 'learner/confirm-invitation/:invitationId',
    component: LearnerPortalRegistrationComponent,
    pathMatch: 'full',
  },
  { path: 'forgot-password', component: ForgotPasswordComponent, pathMatch: 'full' },
  { path: 'reset-password', component: ResetPasswordComponent, pathMatch: 'full' },
  {
    path: 'family',
    children: [
      {
        path: 'login',
        component: FamilyLoginComponent,
        pathMatch: 'full',
      },
      {
        path: 'forgot-password',
        component: FamilyForgotPasswordComponent,
        pathMatch: 'full',
      },
      {
        path: 'reset-password/:userId/:token',
        component: FamilyResetPasswordComponent,
        pathMatch: 'full',
      },
      {
        path: 'locked',
        component: FamilyMemberAccessLockedComponent,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'interactive-access',
    children: [
      {
        path: 'login',
        component: InteractiveAccessLoginComponent,
        pathMatch: 'full',
      },
      {
        path: 'forgot-password',
        component: InteractiveAccessForgotPasswordComponent,
        pathMatch: 'full',
      },
      {
        path: 'reset-password/:userId/:token',
        component: InteractiveAccessResetPasswordComponent,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
